<script setup>
const props = defineProps({
  number: {
    type: [Number, String],
    default: null,
  },
  text: {
    type: String,
    default: '',
  },
  mobile: {
    type: Boolean,
    default: false,
  },
});

const hasNumber = computed(() => props.number !== null && props.number !== '');
</script>

<template>
  <section class="basic-contents-title" :class="{ 'is-mobile': mobile }">
    <span v-if="hasNumber" class="basic-contents-title__num">{{ number }}</span>
    <span class="basic-contents-title__txt" v-html="text" />
  </section>
</template>

<style scoped lang="scss">
.basic-contents-title {
  width: 100%;
  display: flex;
  padding: 24px;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  background: rgba(242, 118, 71, 0.05);

  &__num {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    background: #f27647;
    color: #fff;
    font-family: Pretendard;
    font-size: 12px;
    font-weight: 700;
    line-height: 18px;
  }

  &__txt {
    display: flex;
    flex-wrap: wrap;
    color: #f27647;
    font-family: Pretendard;
    font-size: 16px;
    font-weight: 700;
    line-height: 18px;
  }

  &.is-mobile {
    padding: 20px 24px;
    gap: 10px;
  }
}
</style>
